// extracted by mini-css-extract-plugin
module.exports = {"toast-info":"styles_toast-info__1OKLE","toast-info--icon":"styles_toast-info--icon__2VlUK","toast-info--text":"styles_toast-info--text__1hDSy"};